/* eslint-disable @typescript-eslint/indent */
import React, { useEffect, useState } from 'react';
import { Checkbox, Radio, Typography } from '@pwskills/rachnaui';
// import { ChevronUp, ChevronDown } from '@pwskills/rachnaui/Icons';
// import { useRouter } from 'next/router';
import { classNames } from '@pwskills/rachnaui/utils';
import { IMultiSelect, IQueryType } from '@/interfaces/courseListing';
import { ChevronDown, ChevronUp } from '@pwskills/rachnaui/Icons';
import { QueryLabel, InputType } from '@/interfaces/courseListing.enum';
import { useFilterContext } from '../../../context/FilterContext';

type propType = {
  filterOption: {
    title?: string;
    slug?: string;
    count?: number;
    id: string;
  }[];
  filterType: string;
  type: string;
  isEndOfObject: boolean;
  isStartOfObject: boolean;
  activeFilter: string[];
};

export const queryLabel: IQueryType = {
  Program: QueryLabel.Program,
  'Filter by Profession': QueryLabel.FilterByProfession,
  Domain: QueryLabel.Domain,
  Category: QueryLabel.Category,
  Instructor: QueryLabel.Instructor,
  'Sub Category': QueryLabel.SubCategory,
  Language: QueryLabel.Language,
  Pricing: QueryLabel.Pricing,
  Level: QueryLabel.Level,
  Tags: QueryLabel.Tags,
};

export const isMultiSelect: IMultiSelect = {
  program: false,
  profession: false,
  domain: false,
  category: true,
  subCategory: true,
  instructor: true,
  language: true,
  pricing: false,
  level: false,
  tags: true,
};

const queryIsID: { [key: string]: boolean } = {
  'Filter by Program': false,
  'Filter by Profession': false,
  Domain: true,
  Category: true,
  Instructor: true,
  Language: false,
  'Sub Category': true,
  pricing: false,
  // level: true,
  // tags: true,
};

const FilterCategory = (props: propType) => {
  const { filterOption, filterType, type, isEndOfObject, activeFilter, isStartOfObject } = props;
  const [open, setOpen] = useState(true);
  const [viewMore, setViewMore] = useState(false);
  const [, setSelectedRadio] = useState<string | null>(null);
  const [, setForceRender] = useState(false);
  // const router = useRouter();
  const { filters, setFilter } = useFilterContext();

  const handleFilterClick = (slug: string, optionLabel: string, id: string) => {
    let queryParams = queryLabel[optionLabel];
    const queryValue = filters[queryParams];

    const isId = queryIsID[optionLabel];
    const value = isId ? id : slug;
    queryParams = `${queryParams}`;

    if (type === InputType.radio) {
      setFilter(queryParams, value);
      setSelectedRadio(value);
    } else if (isMultiSelect[queryParams]) {
      if (Array.isArray(queryValue)) {
        if (queryValue.includes(value)) {
          const updatedValues = queryValue.filter((item) => item !== value);
          setFilter(queryParams, updatedValues.length ? updatedValues : []);
        } else {
          setFilter(queryParams, [...queryValue, value]);
        }
      } else if (queryValue === value) {
        setFilter(queryParams, null);
      } else if (queryValue) {
        setFilter(queryParams, [queryValue as string, value]);
      } else {
        setFilter(queryParams, [value]);
      }
    } else {
      setFilter(queryParams, value);
    }

    if (!filters[queryParams]) {
      setFilter('isFilterChecked', true);
    }
  };

  const isChecked = (slug?: string, id?: string, title?: string) => {
    const isId = queryIsID[filterType];
    const slugValue = isId ? id : slug;

    const value = filters[queryLabel[filterType]];

    if (activeFilter && activeFilter.includes(title as string)) {
      return true;
    }
    if (Array.isArray(value)) {
      return value.includes(slugValue as string);
    }
    return slugValue === value;
  };

  useEffect(() => {
    setForceRender((prev) => !prev);
  }, [filters]);

  if (filterOption?.length) {
    return (
      <div
        className={classNames(
          'flex flex-col !gap-5',
          filterOption?.length ? 'border-b border-stroke-200 pb-[15px]' : '',
          isEndOfObject ? ' border-b border-white medium:!border-stroke-200' : '',
          isStartOfObject ? '' : 'pt-6 large:pt-10'
        )}
      >
        <div
          className="flex justify-between cursor-pointer pointer-events-auto medium:pointer-events-none"
          onClick={() => setOpen(!open)}
          aria-hidden
        >
          <Typography component="subheading" variant="bold" className="text-gray-900">
            {filterType}
          </Typography>
          <div className="medium:hidden">
            {open ? (
              <ChevronUp className="w-5 h-5 cursor-pointer" />
            ) : (
              <ChevronDown className="w-5 h-5 cursor-pointer" />
            )}
          </div>
        </div>

        {open && (
          <div className="flex flex-col medium:flex-row !gap-4 text-gray-850 flex-wrap">
            {!viewMore
              ? filterOption?.slice(0, 5)?.map(({ id, title, slug, count }) =>
                  type === InputType.radio && slug ? (
                    <Radio
                      key={slug}
                      checked={isChecked(slug, id, title)}
                      value={slug}
                      label={`${title} ${count && count > 0 ? `(${count})` : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleFilterClick(slug, filterType, id);
                      }}
                      labelClass="font-[700] leading-[22px]"
                    />
                  ) : (
                    <Checkbox
                      key={slug}
                      value={slug}
                      checked={isChecked(slug, id, title)}
                      label={`${title} (${count && count})`}
                      labelClass="font-[700] leading-[22px]"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        if (slug) handleFilterClick(slug, filterType, id);
                      }}
                    />
                  )
                )
              : filterOption?.map(({ title, slug, count, id }) =>
                  type === InputType.radio && slug ? (
                    <Radio
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleFilterClick(slug, filterType, id);
                      }}
                      key={slug}
                      checked={isChecked(slug, id, title)}
                      value={slug}
                      label={`${title} (${count && count})`}
                      labelClass="font-[700] leading-[22px]"
                    />
                  ) : (
                    <Checkbox
                      key={slug}
                      value={slug}
                      checked={isChecked(slug, id, title)}
                      label={`${title} (${count && count})`}
                      labelClass="font-[700] leading-[22px]"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        if (slug) handleFilterClick(slug, filterType, id);
                      }}
                    />
                  )
                )}
            {filterOption.length > 5 && (
              <Typography
                component="body-small"
                variant="semi-bold"
                className="text-orange-500 cursor-default"
                onClick={() => setViewMore(!viewMore)}
              >
                {viewMore ? 'View less' : 'View more'}
              </Typography>
            )}
          </div>
        )}
      </div>
    );
  }
  return null;
};

export default FilterCategory;
